import React, { useState } from 'react';
import './ThirdPartyVerification.css';

function ThirdPartyVerification({ onApprove, onRequestData }) {
  const [checklist, setChecklist] = useState({
    docAuthenticity: false,
    envCompliance: false,
    regFramework: false,
    auditTrail: false,
    legalDefensibility: false,
  });
  const [notes, setNotes] = useState('');

  const handleChecklistChange = (key) => {
    setChecklist(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const allChecksCompleted = Object.values(checklist).every(Boolean);

  const handleApprove = () => {
    if (!allChecksCompleted) {
      alert('Please complete all checklist items before approving.');
      return;
    }
    onApprove();
  };

  return (
    <div className="third-party-verification">
      <header className="tpv-header">
        <h1>Third-Party Verification</h1>
        <p>Regulatory Compliance Review</p>
      </header>

      <div className="tpv-container">
        {/* Verification Authority */}
        <section className="tpv-section">
          <div className="tpv-section-header">Verification Authority</div>
          <div className="tpv-details-grid">
            <div><span>Organization:</span><strong>EcoCert India</strong></div>
            <div><span>Registration:</span><strong>VCS-REG-IN-018</strong></div>
            <div><span>Time-in-Force:</span><strong>FY 2024-Q4-FY25-Q1</strong></div>
            <div><span>Status:</span><strong className="status-active">Active</strong></div>
          </div>
        </section>

        {/* Project Documentation Review */}
        <section className="tpv-section">
          <div className="tpv-section-header">Project Documentation Review</div>
          <div className="tpv-details-grid">
            <div><span>Project ID:</span><strong>MANGROVE-001</strong></div>
            <div><span>Submitted by:</span><strong>MANAV-NEGI</strong></div>
            <div><span>Location:</span><strong>New Delhi, India</strong></div>
            <div><span>Carbon Sequestration:</span><strong>2.3 tons CO₂e</strong></div>
            <div><span>Verifier:</span><strong>Dr. Manav Negi</strong></div>
          </div>
        </section>

        {/* Regulatory Compliance Checklist */}
        <section className="tpv-section">
          <div className="tpv-section-header">Regulatory Compliance Checklist</div>
          <div className="tpv-checklist">
            {Object.keys(checklist).map((key, index) => (
              <label key={index} className="tpv-checklist-item">
                <input type="checkbox" checked={checklist[key]} onChange={() => handleChecklistChange(key)} />
                {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
              </label>
            ))}
          </div>
        </section>

        {/* Risk Assessment */}
        <section className="tpv-section">
          <div className="tpv-section-header">Risk Assessment</div>
          <div className="risk-assessment-grid">
            <div className="risk-item low-risk"><span>Environmental Impact</span></div>
            <div className="risk-item medium-risk"><span>Regulatory Compliance</span></div>
            <div className="risk-item low-risk"><span>Data Quality</span></div>
          </div>
        </section>

        {/* Compliance Notes */}
        <section className="tpv-section">
          <div className="tpv-section-header">Compliance Notes</div>
          <textarea 
            className="tpv-textarea"
            placeholder="Add compliance review notes and observations..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </section>

        {/* Applied Standards */}
        <section className="tpv-section">
          <div className="tpv-section-header">Applied Standards</div>
          <ul className="standards-list">
            <li>Verified Carbon Standard (VCS) for GHG certification and reporting.</li>
            <li>Climate, Community & Biodiversity (CCB) Standards.</li>
            <li>Environmental Impact Assessment (EIA).</li>
            <li>National Action Plan on Climate Change.</li>
          </ul>
        </section>

        {/* Action Buttons */}
        <div className="tpv-actions">
          <button 
            className="tpv-btn approve-btn" 
            onClick={handleApprove} 
            disabled={!allChecksCompleted}
          >
            Approve for Blockchain Registry
          </button>
          <button className="tpv-btn request-btn" onClick={onRequestData}>Request Additional Data</button>
          {!allChecksCompleted && <p className="tpv-warning">Complete all compliance checks to approve submission.</p>}
        </div>
      </div>
    </div>
  );
}

export default ThirdPartyVerification;
